export const SET_BOND_DISCOUNTS = 'SET_BOND_DISCOUNTS'
export const SET_BOND_PURCHASE = 'SET_BOND_PURCHASE'
export const SET_BOND_TREASURY = 'SET_BOND_TREASURY'
export const SET_BOND_TREASURY_FROM_API = 'SET_BOND_TREASURY_FROM_API'
export const CLEAR_BOND_DATA_LIST = 'CLEAR_BOND_DATA_LIST'
